module.exports = __webpack_public_path__ + "img/img_home_vague.af12abbb.png";